/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */

import PaletteIconArrowRight from '@telus-uds/palette-allium/build/rn/icons/ArrowRight'
import PaletteIconArrowLeft from '@telus-uds/palette-allium/build/rn/icons/ArrowLeft'
const theme = {
  appearances: {
    equalWidth: {
      description: 'Divide the available width equally among `TabsItem`',
      type: 'variant',
      values: [ true ]
    },
    inverse: {
      description: 'Styles the link white for use on dark backgrounds.',
      type: 'variant',
      values: [ true ]
    }
  },
  rules: [
    { if: { inverse: true }, tokens: { borderBottomColor: '#ffffff' } }
  ],
  tokens: {
    borderBottomColor: '#676e73',
    borderBottomWidth: 1,
    buttonClearance: 16,
    gutter: 4,
    nextIcon: PaletteIconArrowRight,
    previousIcon: PaletteIconArrowLeft,
    space: 0
  }
}
export default theme
